module.exports = __webpack_public_path__ + "img/40.b7cf20d2.jpg";